import { Link } from "react-router-dom";
import { useState } from "react";
import { ArrowRight, Smartphone } from "lucide-react";

import vectorProfile from "../../assets/images/vectorProfile.svg";
import dummyUser from "../../assets/images/dummyUser.svg";
import UserDetails from "../UI/UserUI/UserDetails";
import useImageUrl from "../../CustomHooks/useImageUrl";
import ImageSlider from "../UI/viewDialogs/ImageSlider";
import UseDialogBox from "../../CustomHooks/UseDialogBox";
import { mapRoles } from "../../utils/roles";
import MobileVerify from "../auth/MobileVerify";

const HomeProfileBox = ({ data }) => {
  const { claims, userData } = data;
  const [openVerify, setOpenVerify] = useState(false);
  const roles = claims.role;
  const { getImageUrl } = useImageUrl();
  const { showDialogBox, setShowDialogBox } = UseDialogBox();
  const roleValues = roles.map((role, ind) => {
    return (
      <span key={role}>
        {mapRoles[role]}
        {role.length - 1 !== ind && ", "}
      </span>
    );
  });
  return (
    <div className="home-profile-main">
      <div className="home-profile-wrap">
        <div className="home-profile-top">
          <img
            src={
              userData.profilePicUrlList
                ? getImageUrl(userData.profilePicUrlList[0])
                : dummyUser
            }
            alt="userProfile"
            className="home-profile-pic"
          />
          <img
            src={vectorProfile}
            alt="vectorProfile"
            className="home-profile-vector"
          />
        </div>
        <div className="pt-9 pl-5 pr-5">
          <div className="relative">
            <h4 className="home-profile-h">Personal info</h4>
            <UserDetails title="Full name" value={userData.fullName} />
            <UserDetails title="Email" value={userData.email} />
            <UserDetails title="Mobile Number" value={userData.mobileNumber} />
            {userData.idProofUrlList && (
              <button
                className="rounded-btn homeIdProof"
                onClick={() => setShowDialogBox(true)}
              >
                View ID Proof
              </button>
            )}
          </div>

          <div>
            <h4 className="home-profile-h mt-4 2xs:max-sm:mt-2">
              Company info
            </h4>

            <div className="capitalize">
              <UserDetails title="Role" value={roleValues} />
            </div>
            <UserDetails
              title="Supervisor (JBCC)"
              value={userData.jbccSupervisor?.fullName ?? "N/A"}
            />

            <UserDetails
              title="Supervisor (JN)"
              value={userData.jnSupervisor?.fullName ?? "N/A"}
            />
            <UserDetails
              title="Admin (JBCC)"
              value={userData.jbccAdmin?.fullName ?? "N/A"}
            />

            <UserDetails
              title="Admin (JN)"
              value={userData.jnAdmin?.fullName ?? "N/A"}
            />

            <UserDetails
              title="Bike registration no."
              value={userData.bikeRegNumber ?? "Not Available"}
            />
            <UserDetails
              title="Total Balance"
              value={`₹${userData.totalBalance}`}
            />
          </div>
          <div className="sm:flex sm:gap-2 sm:items-center max-md:mt-3 md:mt-7">
            <Link className={`home-view-profile-btn`} to="/profile">
              View Profile
              <ArrowRight color="white" size={18} className="ml-2" />
            </Link>
            {!userData.isPhoneVerified && (
              <button
                className="verifyPhoneBtnMain"
                onClick={() => setOpenVerify(true)}
              >
                <Smartphone size={15} />
                Verify Phone
              </button>
            )}
          </div>
        </div>
      </div>
      {showDialogBox && (
        <ImageSlider
          title="Id Proof Photo"
          images={userData.idProofUrlList}
          imageSliderCurrentIndex={0}
          closeDialogBox={() => setShowDialogBox(false)}
        />
      )}
      {openVerify && (
        <MobileVerify phone={userData.mobileNumber} setOpen={setOpenVerify} />
      )}
    </div>
  );
};

export default HomeProfileBox;
